import { Form, Input, Button } from 'antd';
import { ReactComponent as PasswordHide } from '@/assets/icons/hidepassword.svg';
import {ReactComponent as PasswordShow } from  '@/assets/icons/showpassword.svg';
import '../index.less';
import rules from '@/config/rules';

const SetPasswordRender = ({requestSetPassword,submitLoading}) => {
    const [form] = Form.useForm();

    /**
  * 自定义密码显示和隐藏icon
  * @param {*} visible
  */
    const passWordIconRender = visible => (visible ? <PasswordShow /> : <PasswordHide />);

    return (
        <div className="set-new-password-page text-center">
            <div className="topContent">
                <h1 className='text-white mb-0 fw-bold'>设置新密码</h1>
            </div>
            <div className='section-set-pwd'>
                <div className='container'>
                    <div className='retrievePwdForm bg-white mx-auto rounded-3'>
                        <Form
                            name="form"
                            form={form}
                            onFinish={requestSetPassword}
                            validateTrigger="onBlur"
                            autoComplete="off"
                            className='text-start'
                        >
                            <Form.Item
                                className='require_item'
                                name="password"
                                rules={[{ required: true, message: '请输入您的新密码!' },
                                { pattern: new RegExp(rules.password), message: '密码格式错误，8~20位字符，必须包含数字与字母，不允许出现中文与空格。' }
                            ]}
                            >
                                <Input.Password placeholder='请输入您的新密码' iconRender={passWordIconRender}/>
                            </Form.Item>
                            <Form.Item
                                className='require_item'
                                name="password_confirmation"
                                rules={[{ required: true, message: '两次密码不一致,请重新输入' }]}
                            >
                                <Input.Password placeholder='确认密码' iconRender={passWordIconRender}/>
                            </Form.Item>
                            <Form.Item className='text-center mb-0 pb-0'>
                                <Button className='ant-btn ant-btn-primary ant-btn-lg submitButton fs-5 fw-bold' htmlType="submit" loading={submitLoading}>
                                    确定
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SetPasswordRender;
